<template>
  <div>
    <h5 class="text-green mt_18">謹致:</h5>
    <div class="printProposal__sincerely d-flex mt_5">
      <div class="printProposal__sincerely__item">
        <div class="radio radio-inline mr_0" v-if="MfViewing.insurer">
          <input
            type="radio"
            id="sincerely__insurer"
            value="1"
            v-model="sincerelySelect_scope"
            name="sincerely"
          />
          <label for="sincerely__insurer"></label>
        </div>
        <div class="mf-textWrap">
          要保人:{{ truncate(MfViewing.insurer.insured_name) }}
        </div>
      </div>
      <select
        class="form-control ml_5"
        :class="{ disabled: sincerelySelect != '1' }"
        style="width: 7rem"
        id="sincerely__insurer__select"
        v-model="sincerely__insurerTitle_scope"
      >
        <option value="">請選擇</option>
        <option value="先生">先生</option>
        <option value="小姐">小姐</option>
        <option value="女士">女士</option>
        <option value="保戶">保戶</option>
      </select>
      <div class="printProposal__sincerely__item ml_25">
        <div class="radio radio-inline mr_0" v-if="MfViewing.insured">
          <input
            type="radio"
            id="sincerely__insured"
            value="2"
            v-model="sincerelySelect_scope"
            name="sincerely"
          />
          <label for="sincerely__insured"></label>
        </div>
        <div class="mf-textWrap">
          被保險人:{{ truncate(MfViewing.insured.insured_name) }}
        </div>
      </div>
      <select
        class="form-control ml_5"
        :class="{ disabled: sincerelySelect != '2' }"
        style="width: 7rem"
        id="sincerely__insured__select"
        v-model="sincerely__insuredTitle_scope"
      >
        <option value="">請選擇</option>
        <option value="先生">先生</option>
        <option value="小姐">小姐</option>
        <option value="女士">女士</option>
        <option value="保戶">保戶</option>
      </select>
    </div>
    <div class="printProposal__sincerely d-flex mt_5">
      <div class="printProposal__sincerely__item" style="width: auto">
        <div class="radio radio-inline mr_0">
          <input
            type="radio"
            id="sincerely__other"
            value="3"
            v-model="sincerelySelect_scope"
            name="sincerely"
          />
          <label for="sincerely__other"></label>
        </div>
        <div>自行輸入姓名</div>
      </div>
      <div class="position-relative ml_5">
        <input
          type="text"
          maxlength="13"
          v-model="sincerely__otherTitle_scope"
          style="width: 400px"
          class="form-control form-control-inline"
          alt="ch"
        />
      </div>
    </div>
  </div>
</template>

<script>
import mf_Mixin from "@/desktop/views/mf/mixin";
import { mapGetters, mapActions } from "vuex";
import { commonMixin } from "@/mixins/common";

export default {
  mixins: [mf_Mixin, commonMixin],
  props: [
    "sincerelySelect",
    "sincerely__otherTitle",
    "sincerely__insuredTitle",
    "sincerely__insurerTitle",
  ],
  computed: {
    ...mapGetters(["CustInfo", "UserInfo", "MfViewing"]),
    sincerelySelect_scope: {
      get() {
        return this.sincerelySelect;
      },
      set(val) {
        this.$emit("update:sincerelySelect", val);
      },
    },
    sincerely__otherTitle_scope: {
      //除六個原住民姓名特殊符號(ʼ⌃ṟéɨʉ)外，不容許特殊符號。
      get() {
        return this.sincerely__otherTitle.replace(/[<>!@#$^&,."'?%*;_()+-/{}[\]|~`=\\\s]/g,'');
      },
      set(val) {
        if (val === this.sincerely__otherTitle) {
          val = val.replace(/[<>!@#$^&,."'?%*;_()+-/{}[\]|~`=\\\s]/g,'');
        }
        this.$emit("update:sincerely__otherTitle", val);
      },
    },
    sincerely__insuredTitle_scope: {
      get() {
        return this.sincerely__insuredTitle;
      },
      set(val) {
        this.$emit("update:sincerely__insuredTitle", val);
      },
    },
    sincerely__insurerTitle_scope: {
      get() {
        return this.sincerely__insurerTitle;
      },
      set(val) {
        this.$emit("update:sincerely__insurerTitle", val);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.printProposal__sincerely {
  .form-control.disabled {
    background-color: #f5f5f5;
    border: none;
    pointer-events: none;
  }
  &__item {
    padding: 0 10px;
    display: flex;
    align-items: center;
    background-color: #f5f5f5;
    &:nth-of-type(1) {
      width: 223px;
    }
    &:nth-of-type(2) {
      width: 239px;
    }
  }
}
</style>
